angular.module('charts')
  .directive('bubbleGraph', function() {
    return {
      restrict: 'E',
      scope: {
        graphData: '=data',
        busy: '=busy'
      },
      templateUrl: '/resources/charts/partials/bubble-graph.html',
      controller:  ['$scope', '$window', '$element', '$rootScope', function($scope, $window, $element, $rootScope) {

        var MIN_POINTS_FOR_CLUSTERING = 26;
        var SCHOOL_POINT_SIZE = 20;
        var MIN_CLUSTER_SIZE = 30;
        var MAX_CLUSTER_SIZE = 90;

        var scatterplotConfigs = {
          chart: {
            type: 'bubble',
            width: 470,
            height: 470,
            marginTop: 40,
            events: {
              drilldown: function() {
                // Set the minRange and min values to null (from 0) so the graph can zoom on drilldown
                this.xAxis[0].update({
                  minRange: null,
                  min: null,
                });
                this.yAxis[0].update({
                  minRange: null,
                  min: null,
                });
              },
              drillup: function() {
                // Reset the minRange and min values for each axis on drillup
                // We want to show at least 0min usage to 60min usage and 0% to 100% growth
                this.xAxis[0].update({
                  minRange: 60,
                  min: 0,
                });
                this.yAxis[0].update({
                  minRange: 100,
                  min: 0,
                });
              },
            },
            style: {
              fontFamily: '"Proxima Nova Condensed", Arial, sans-serif',
              fontSize: '1em',
            },
          },
          // Hide highcharts tag at bottom of chart
          credits: false,
          // Hide default title
          title: {
            text: ''
          },
          drilldown: {
          },
          legend: {
              enabled: false
          },
          plotOptions: {
            bubble: {
              // PointSelect is used to highlight points on hover/click and enable tooltip click for drilldown
              allowPointSelect: true,
              color: '#72c7e7',
              marker: {
                states:{
                  hover: {
                    enabled: false,
                  },
                  select: {
                    enabled: true,
                    lineWidth: 3,
                    lineColor: 'white',
                    fillColor: '#72c7e7',
                  },
                },
              },
              // Default minSize and maxSize values, these are always overwritten
              minSize: MIN_CLUSTER_SIZE,
              maxSize: MAX_CLUSTER_SIZE,
              point: {
                // Change selected states on mouse events
                events: {
                  click: function() {
                    if ((this.selected)) {
                      this.select(false, true);
                    }
                  },
                  mouseOver: function() {
                    if (!(this.selected)) {
                      this.select(true, true);
                    }
                  },
                  mouseOut: function() {
                    if (this.selected) {
                      this.select(false, true);
                    }
                  },
                },
              },
            },
          },
          series: [],
          tooltip: {
            backgroundColor: "rgba(255, 253, 250, 1)",
            borderWidth: 0,
            hideDelay: 0,
            // Allow full HTML in tooltips instead of limited subset of HTML
            useHTML: true,
            formatter: function() {
              if (this.series.name === 'Clusters') {
                return '<div class="tooltip-wrapper tooltip-cluster" id="tooltip-wrapper"><div class="tooltip-details"><p class="tooltip-name">Cluster</p><p class="tooltip-usage">Click to expand</p></div><p class="tooltip-growth"><span class="tooltip-percentage">' + this.point.z + '<br/></span>Schools</p></div>';
              }
              else {
                return '<div class="tooltip-wrapper"><div class="tooltip-details"><p class="tooltip-name">' + this.point.name + '</p><p class="tooltip-usage">' + this.x + ' mins. average weekly usage </p></div><p class="tooltip-growth"><span class="tooltip-percentage">' + Math.round(this.y*10)/10 + '%<br/></span>Growth</p></div>';
              }
            }
          },
          xAxis: {
            type: 'linear',
            lineColor: '#C0C0C0',
            tickColor: '#C0C0C0',
            gridLineWidth: 1,
            title: {
              text: "Average Minutes per Week"
            },
            labels: {
              y: 25,
              style: {
                fontSize: '16px'
              },
            },
            min: 0,
            minRange: 60,
            maxPadding: 0.1,
          },
          yAxis: {
            title: {
              text: "Growth"
            },
            labels: {
              format: "{value:.1f}%",
              style: {
                fontSize: '16px'
              }
            },
            min: 0,
            minRange: 100
          },
        };

        // Extend highcharts to support tooltip click events
        (function (H) {
          // Trigger drilldown on tooltip click
          H.wrap(H.Chart.prototype.callbacks.push(function (chart) {
            H.addEvent(chart.tooltip.label.div, 'click', function (e) {
              var chart = $('#container').highcharts();
              var selectedPoints = chart.getSelectedPoints();
              if (selectedPoints[0].isCluster === true) {
                selectedPoints[0].doDrilldown();
              }
              else if (!$rootScope.isEarlierYearSelected){
                $scope.$emit('listTableRowClicked', selectedPoints[0]);
              }
            });
          }));

          // Disalbe drilldown on point click
          H.wrap(H.Point.prototype, 'init', function (proceed, series, options, x) {
            var point = proceed.call(this, series, options, x);
            if (point.drilldown) {
              H.removeEvent(point, 'click');
              H.addEvent(point, 'click', function () {
              });
            }
            return point;
          });
        }(Highcharts));

        // Create usable points from the schools g2 return
        var getPointsFromSchools = function(schools) {
          var points = [];
          _.each(schools, function(school) {
              var schoolPoint = {
                name: school.name,
                // Convert ms to minutes
                x: Math.round(school.average_weekly_session_time/60000),
                y: school.percent_growth,
                z: 1,
                type: "school",
                id: school.id,
              };
              points.push(schoolPoint);
            });
          return points;
        };

        var getNumClusters = function(numPoints) {
          // Formula: number of points = number of clusters * 20 - 70 or y=20x-70
          return Math.floor((numPoints + 70)/20);
        };

        var getEuclidianDistance = function(x1, y1, x2, y2) {
          return Math.sqrt(Math.pow((x2 - x1), 2) + Math.pow((y2 - y1), 2));
        };

        // Minimum cluster size is 30 (school point size is 20)
        // The maximum cluster size is calculated based on the ratio fo the largest cluster to the smallest cluster
        // Ideally, if the largest cluster is twice as big as the smallest cluster then the max cluster size will be twice the min cluster size
        // Cluster size is capped at 90 so giant clusters don't take over the whole graph
        var getMaxClusterSize = function(clusterList) {
          var smallestClusterSize = _.min(clusterList, function(o) { return o.z; }).z;
          var largestClusterSize = _.max(clusterList, function(o) { return o.z; }).z;
          var ratio = largestClusterSize/smallestClusterSize;
          if (MIN_CLUSTER_SIZE*ratio > MAX_CLUSTER_SIZE) {
            return MAX_CLUSTER_SIZE;
          }
          else {
            return MIN_CLUSTER_SIZE*ratio;
          }
        };

        // This function checks the dataset to decide if clustering is necessary
        // If not, create points and append them to the graph and return
        // If clustering is necessary, use k-means to create clusters, then setup the drilldown and append the necessary data to the chart
        /* jshint -W071 */ // TODO: fix maxstatements violation
        /* jshint -W074 */ // TODO: fix maxcomplexity violation
        var calculateClusters = function() {
          var i, j;
          var points = getPointsFromSchools($scope.graphData);
          var numPoints = points.length;
          // Decide whether to cluster based on dataset size
          if (numPoints < MIN_POINTS_FOR_CLUSTERING) {
            // If not clustering, setup chart and return
            var schoolData = [{
              name: 'Schools',
              colorByPoint: false,
              data: [],
              states: {
                hover: {
                  halo: false,
                }
              },
              minSize: SCHOOL_POINT_SIZE,
              maxSize: SCHOOL_POINT_SIZE,
            }];
            schoolData[0].data = points;
            scatterplotConfigs.series = schoolData;
            return;
          }
          // If clustering, decide number of clusters based dataset size
          var numClusters = getNumClusters(numPoints);
          // Initialize clusters, each cluster is initially located at a point
          var clusterList = [];
          for (i = 0; i < numClusters; i++) {
            var newCluster = {};
            newCluster.id = i;
            newCluster.x = points[i].x;
            newCluster.y = points[i].y;
            newCluster.z = 1;
            clusterList.push(newCluster);
          }
          // Iterate centers until they don't move anymore
          var clustersMoving = false;
          do {
            clustersMoving = false;
            // Set nearestClusterIndex for each point
            for (i = 0; i < numPoints; i++) {
              var minDistance = null;
              for (j = 0; j < numClusters; j++) {
                var distance = getEuclidianDistance(points[i].x, points[i].y, clusterList[j].x, clusterList[j].y);
                if (minDistance === null || distance < minDistance) {
                  minDistance = distance;
                  points[i].nearestClusterIndex = j;
                }
              }
            }
            // Move clusters to the average positoin of all their nearest points
            // The ith index of xTotals contains the sum of the x-values of the points closest to the ith cluster. yTotals is similar
            var xTotals = new Array(numClusters);
            var yTotals = new Array(numClusters);
            // The ith index of pointsPerCluster is the number of points that are currently closest to the ith cluster
            // This is used to compute the average coordinates using xTotals and yTotals
            var pointsPerCluster = new Array(numClusters);
            // Initialize arrays to 0
            for (i = 0; i < numClusters; i++) {
              xTotals[i] = 0;
              yTotals[i] = 0;
              pointsPerCluster[i] = 0;
            }
            // Record the coordinates of each point so they can be averaged
            for (i = 0; i < numPoints; i++) {
              xTotals[points[i].nearestClusterIndex] += points[i].x;
              yTotals[points[i].nearestClusterIndex] += points[i].y;
              pointsPerCluster[points[i].nearestClusterIndex]++;
            }
            // Move each cluster to the average of its closest points, check if any of them have moved
            for (i = 0; i < numClusters; i++) {
              clusterList[i].oldX = clusterList[i].x;
              clusterList[i].oldY = clusterList[i].y;
              clusterList[i].x = xTotals[i]/pointsPerCluster[i];
              clusterList[i].y = yTotals[i]/pointsPerCluster[i];
              clusterList[i].z = pointsPerCluster[i];
              if (clustersMoving === false && (clusterList[i].oldX !== clusterList[i].x || clusterList[i].oldY !== clusterList[i].y) &&
                    (!isNaN(clusterList[i].x) && !isNaN(clusterList[i].y))) {
                // sometimes values are cuddled so close together, the number of clusters is reduced by virtue of the sheer number of points in close proximity
                // in those cases, we check for "clusters" in the cluserList that have bad x/y values and don't turn on moving
                clustersMoving = true;
              }
            }
          }
          while (clustersMoving === true);
          // Create cluster JSON with drilldown IDs and append to graph data
          var clustersSeries = [{
            name: 'Clusters',
            colorByPoint: false,
            data: [],
            minSize: MIN_CLUSTER_SIZE,
            states: {
              hover: {
                halo: false,
              }
            }
          }];
          // Move all of this into the clusters list initialization and 'move cluster' sections then just push the clusterLists items into the clusterSeries[0].data
          for (i = 0; i < numClusters; i++) {
            var clusterObject = {
              name: 'Cluster ' + (i + 1),
              x: clusterList[i].x,
              y: clusterList[i].y,
              z: clusterList[i].z,
              isCluster: true,
              drilldown: 'cluster' + (i + 1),
            };
            clustersSeries[0].data.push(clusterObject);
          }
          // Set the maximum cluster size based on the ratio of the smallest cluster to the biggest cluster
          clustersSeries[0].maxSize = getMaxClusterSize(clusterList);

          scatterplotConfigs.series = clustersSeries;
          // Create drilldown JSONs for each cluster and append them to drilldown data
          var drilldownData = {
            drillUpButton: {
              position: {
                x: -5,
                y: -33,
              },
              relativeTo: "plotBox",
            },
            series: []
          };
          for (i = 0; i < numClusters; i++) {
            var newSeries = {
              data: [],
              id: 'cluster' + (i + 1),
              name: 'Cluster ' + (i + 1),
              maxSize: SCHOOL_POINT_SIZE,
              minSize: SCHOOL_POINT_SIZE,
              states: {
                hover: {
                  halo: false
                }
              }
            };
            drilldownData.series[i] = newSeries;
          }
          for (i = 0; i < numPoints; i++) {
            drilldownData.series[points[i].nearestClusterIndex].data.push(points[i]);
          }
          scatterplotConfigs.drilldown = drilldownData;
          return;
        };
        /* jshint +W071 */
        /* jshint +W074 */


        var initializeScatterplot = function() {
          $('#container').highcharts(scatterplotConfigs);
        };

        $scope.$watch('graphData', function(newValue, oldValue) {
          // no data
          if (!newValue || !newValue.length) {
            return;
          }
          // data is hasn't changed
          if (angular.equals(newValue, oldValue)) {
            return;
          }
          calculateClusters();
          initializeScatterplot();
        });

        $scope.$on("$destroy", function() {
          while (Highcharts.Chart.prototype.callbacks.length > 0) {
            Highcharts.Chart.prototype.callbacks.pop();
          }
        });

      }]
    };
  });
